export interface IArea {
  id: number
  name: string
  parentId?: number
  successorHierarchy?: number[]
}

export const IAreaInitialState: IArea = {
  id: 0,
  name: '',
  parentId: undefined,
}
